import {
  ValidatorFn,
  AbstractControl,
  ValidationErrors,
  Validators,
} from '@angular/forms';

export const errorObjectBuilder = (message: string) => ({
  message,
});

/**
 * Decides if a field contains no special chars
 * @param {string} fieldName name of the required field
 * @return {ValidatorFn}
 */
export function requiredValidator(fieldName: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const customMessage = fieldName;
    const error = Validators.required(control);
    return error ? { required: customMessage } : null;
  };
}
